import { inlineHtml, isBlock, isBr, isItem, isList } from "../helpers";
import type { ListItemNode, ListNode } from "../types";
import { parseHtmlPair } from "./pair";

interface Collector {
  forList: boolean;
  labels: string[];
  items: ListItemNode[];
  lists: ListNode[];
}

const collect = (node: Node, c: Collector, direct: boolean) => {
  let run: Node[] = [];
  const flush = () => {
    const html = inlineHtml(run).trim();
    if (html) c.labels.push(html);
    run = [];
  };
  node.childNodes.forEach((child) => {
    if (isBr(child)) {
      flush();
    } else if (isList(child)) {
      flush();
      const list = parseList(child);
      if (c.forList) c.items.push({ type: "li", level: 0, label: "", children: [list] });
      else c.lists.push(list);
    } else if (direct && c.forList && isItem(child)) {
      flush();
      c.items.push(parseItem(child));
    } else if (isBlock(child)) {
      flush();
      collect(child, c, false);
    } else {
      run.push(child);
    }
  });
  flush();
};

const withPair = <T extends ListNode | ListItemNode>(node: T): T => {
  const pair = parseHtmlPair(node.label);
  if (pair) node.pair = pair;
  return node;
};

const parseItem = (li: Element): ListItemNode => {
  const c: Collector = { forList: false, labels: [], items: [], lists: [] };
  collect(li, c, true);
  return withPair<ListItemNode>({ type: "li", level: 0, label: c.labels.join("\n"), children: c.lists });
};

const parseList = (list: Element): ListNode => {
  const c: Collector = { forList: true, labels: [], items: [], lists: [] };
  collect(list, c, true);
  return withPair<ListNode>({
    type: list.tagName === "OL" ? "ol" : "ul",
    level: 0,
    label: c.labels.join("\n"),
    children: c.items,
  });
};

export { parseList };
